export default __webpack_public_path__ + "static/media/nl.2bacea9c.png";